<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<a id="dedi_1">
</a>
<p class="ded1">To Jeanne Rose Fontana Lower (Mills College ’39),<br/>and to Ray Lower, <em>in memoriam</em>, for their generous<br/> support through the years, access to their wonderful<br/> library and knowledge of all things Sinclair, and<br/> for introducing me to Donal Sean.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofStorms_dedi_1.vue?2360b687